import * as React from 'react';
import {emotionStyled, tokens} from '@packages/utilities/styled';
import {Form12 as FormSmall} from '@packages/systems/ui/icons';
import {ElementFormBlockIcon} from '@packages/systems/spring';

const IconWrapper = emotionStyled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: tokens.colors.actionPrimaryBackground,
  width: '100%',
  height: '100%',
});

export const formSubmissionIcons = {
  ElementFormBlockIcon,
  FormSubmissionDetail: () => (
    <IconWrapper>
      <ElementFormBlockIcon size={20} />
    </IconWrapper>
  ),
  FormSubmissionDetailSmall: FormSmall,
} as const;
